import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Input from '../components/common/Input';
import Button from '../components/common/Button';
import { isValidEmail } from '../utils/helpers';
import axios from 'axios'; // Or your auth service

const ForgotPasswordPage = () => {
  const [step, setStep] = useState(1); // 1: Email, 2: OTP & Reset
  const [email, setEmail] = useState('');
  const [otpData, setOtpData] = useState({ otp: '', newPassword: '' });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });

  const handleSendOtp = async (e) => {
    e.preventDefault();
    if (!isValidEmail(email)) return setMessage({ type: 'error', text: 'Valid email required' });

    try {
      setLoading(true);
      // This calls your Spring Boot backend (which uses Brevo)
      await axios.post('/api/auth/forgot-password', { email });
      setStep(2);
      setMessage({ type: 'success', text: 'OTP sent to your email!' });
    } catch (err) {
      setMessage({ type: 'error', text: 'Failed to send OTP. Try again.' });
    } finally {
      setLoading(false);
    }
  };

  const handleResetPassword = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      await axios.post('/api/auth/reset-password', { 
        email, 
        otp: otpData.otp, 
        newPassword: otpData.newPassword 
      });
      setMessage({ type: 'success', text: 'Password reset successful! You can now login.' });
      setStep(3); // Show success view
    } catch (err) {
      setMessage({ type: 'error', text: 'Invalid OTP or expired.' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full bg-white p-8 rounded-lg shadow-md">
        <h2 className="text-2xl font-bold text-center mb-6">
          {step === 1 ? 'Forgot Password' : 'Reset Password'}
        </h2>

        {message.text && (
          <div className={`mb-4 p-3 rounded ${message.type === 'error' ? 'bg-red-50 text-red-600' : 'bg-green-50 text-green-600'}`}>
            {message.text}
          </div>
        )}

        {step === 1 && (
          <form onSubmit={handleSendOtp} className="space-y-4">
            <Input label="Email Address" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
            <Button type="submit" fullWidth loading={loading}>Send OTP</Button>
          </form>
        )}

        {step === 2 && (
  <form onSubmit={handleResetPassword} className="space-y-4">
    {/* OTP Input */}
    <Input 
      label="Enter 6-Digit OTP" 
      type="text" 
      maxLength="6" 
      value={otpData.otp} 
      onChange={(e) => setOtpData({...otpData, otp: e.target.value})} 
      required 
    />
    
    {/* New Password */}
    <Input 
      label="New Password" 
      type="password" 
      value={otpData.newPassword} 
      onChange={(e) => setOtpData({...otpData, newPassword: e.target.value})} 
      required 
    />

    {/* Confirm New Password */}
<Input 
  label="Confirm New Password" 
  type="password" 
  value={otpData.confirmPassword} 
  onChange={(e) => setOtpData({...otpData, confirmPassword: e.target.value})} 
  required 
  error={
    otpData.confirmPassword && otpData.newPassword !== otpData.confirmPassword 
    ? "Passwords do not match" 
    : ""
  }
/>

    <Button 
      type="submit" 
      fullWidth 
      loading={loading}
      disabled={otpData.newPassword !== otpData.confirmPassword || otpData.newPassword === ''}
    >
      Update Password
    </Button>
  </form>
)}

        {step === 3 && (
          <div className="text-center">
            <Link to="/login" className="text-blue-600 font-medium">Back to Login</Link>
          </div>
        )}
      </div>
    </div>
  );
};

export default ForgotPasswordPage;